"use client";

import Image from "next/image";
import { Button } from "@/components/ui/button";
import { Card, CardFooter, CardHeader } from "@/components/ui/card";

export function RewardCard({
  img,
  cryptoSymbol,
  cryptoBalance,
  usdBalance,
}: {
  img: string;
  cryptoSymbol: string;
  cryptoBalance: number;
  usdBalance: number;
}) {
  return (
    <Card className="bg-transparent">
      <CardHeader className="flex-row gap-3 space-y-0">
        <div className="bg-accent grid size-10 place-items-center rounded-lg">
          <Image
            src={img}
            alt={cryptoSymbol}
            className="h-6 w-6"
            width={256}
            height={256}
          />
        </div>
        <div className="space-y-0.5">
          <div className="text-foreground text-xs font-normal">
            Available to claim
          </div>
          <div className="text-sm font-medium text-white">
            {new Intl.NumberFormat("en-US", {
              notation: "compact",
              compactDisplay: "short",
            }).format(cryptoBalance)}{" "}
            <span className="text-foreground">
              {cryptoSymbol} (
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                notation: "compact",
                compactDisplay: "short",
              }).format(usdBalance)}
              )
            </span>
          </div>
        </div>
      </CardHeader>
      <CardFooter className="px-[3px] pb-[3px]">
        <Button
          size="sm"
          className="bg-primary/5 text-primary hover:bg-primary hover:text-primary-foreground w-full rounded-t-[3px] rounded-b-[9px]"
        >
          Claim Now
        </Button>
      </CardFooter>
    </Card>
  );
}
